module.exports = __webpack_public_path__ + "img/Medical Examination.7bfcaaec.svg";